import { render, staticRenderFns } from "./ForgotPasswordAdmin.vue?vue&type=template&id=c8ac2fd6&scoped=true"
import script from "./ForgotPasswordAdmin.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordAdmin.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordAdmin.vue?vue&type=style&index=0&id=c8ac2fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ac2fd6",
  null
  
)

export default component.exports